import React from "react";
import WarningIcon from "@material-ui/icons/WarningTwoTone";
import {
  BANNER_COLORS,
  QR_PAYMENT_STATUS_CODES,
} from "ui/pages/transactions/QrPayments/constants/qrPayments.constants";
import { navigateToQrPaymentsList } from "ui/pages/transactions/QrPayments/utils/qrPayments.utils";
import { InfoOutlined } from "@material-ui/icons";
import { useQrWarningBanner } from "../hooks/useQrWarningBanner";

export const QrPaymentsWarningBanner = () => {
  const { successCount, failedCount, isSuccess } = useQrWarningBanner();

  // If no matching payments, do not render banner
  if (successCount === 0 && failedCount === 0) {
    return null;
  }

  // Navigation click handler to redirect to QR Payments list with corresponding status filter
  const handleClick = () => {
    const status = isSuccess
      ? QR_PAYMENT_STATUS_CODES.SUCCESS
      : QR_PAYMENT_STATUS_CODES.FAILED;
    navigateToQrPaymentsList({ status });
  };

  const backgroundColor = isSuccess
    ? BANNER_COLORS.SUCCESS_BG
    : BANNER_COLORS.FAILED_BG;
  const textColor = isSuccess
    ? BANNER_COLORS.SUCCESS_TEXT
    : BANNER_COLORS.FAILED_TEXT;

  return (
    <div
      className="tw-w-full tw-flex tw-items-center tw-justify-center tw-py-[10px] tw-px-4 tw-cursor-pointer"
      style={{
        backgroundColor,
        color: textColor,
      }}
      onClick={handleClick}
    >
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-3">
        {isSuccess ? (
          <InfoOutlined
            className="!tw-text-[24px] tw-flex-shrink-0"
            style={{ color: textColor }}
          />
        ) : (
          <WarningIcon
            className="!tw-text-[24px] tw-flex-shrink-0"
            style={{ color: textColor }}
          />
        )}

        <div className="tw-text-left">
          {isSuccess ? (
            <span>
              A new QR payment was made. Please click here to add customer
              details.
            </span>
          ) : (
            <span>
              A QR payment has failed. Please click here to view the failed
              payments.
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default QrPaymentsWarningBanner;
